import SiteHeader from "./components/SiteHeader";
import Hero from "./components/Hero";
import TimelineSection from "./components/TimelineSection";
import DiscussionSection from "./components/DiscussionSection";
import ReviewSection from "./components/ReviewSection";
import HotRankSection from "./components/HotRankSection";
import TopicsSection from "./components/TopicsSection";
import FollowUpSection from "./components/FollowUpSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <TimelineSection />
        <DiscussionSection />
        <ReviewSection />
        <HotRankSection />
        <TopicsSection />
        <FollowUpSection />
      </main>
      <SiteFooter />
    </div>
  );
}